/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { lAC_GetAllergensAsync } from '../custom-actions/DataActionExtension.g';
import { IFoodPreferenceItem, ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';

/**
 * GetAllergens Input Action
 */
export class GetAllergensInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public customerId: string;

    constructor(customerId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.customerId = customerId;
    }

    public getCacheKey = () => 'LACGETALLERGENS';
    public getCacheObjectType = () => 'LACGETALLERGENS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * The allergens the venue lists in HQ, which a guest can set on their order.
 */
async function getAllergensAsync(input: GetAllergensInput, ctx: Msdyn365.IActionContext): Promise<IFoodPreferenceItem[]> {
    const result = await withFreshToken(ctx, input.authTokenCookie, async carried =>
        lAC_GetAllergensAsync({ callerContext: ctx }, carried, input.customerId)
    );

    return result?.Items ?? [];
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IFoodPreferenceItem[]>>getAllergensAsync,
    id: 'LACGetAllergens'
});
